export enum DecubitusStadium {
  ONE = 'ONE',
  TWO = 'TWO',
  THREE = 'THREE',
  FOUR = 'FOUR',
  OTHER = 'OTHER',
}
